module.exports = __webpack_public_path__ + "img/psaltire-1791-pagina-de-titlu-big.933aab28.png";